export const FORM_PATH_TO_CHANGES_KEY: Record<string, string> = {
  "patient.firstName": "patient.firstName",
  "patient.lastName": "patient.lastName",
  "patient.dateOfBirth": "patient.dateOfBirth",
  "patient.sex": "patient.sex",
  "patient.medicalRecordNumber": "patient.medicalRecordNumber",
  "patient.mobilePhone": "contact.mobilePhone",
  "patient.homePhone": "contact.homePhone",
  "patient.workPhone": "contact.workPhone",
  "patient.email": "contact.email",
  "patient.address.street": "address.street",
  "patient.address.state": "address.state",
  "patient.address.city": "address.city",
  "patient.address.zipCode": "address.zipCode",
  "primaryInsurance.policyNumber": "primaryInsurance.policyNumber",
  "primaryInsurance.authorizationNumber":
    "primaryInsurance.authorizationNumber",
  "primaryInsurance.groupNumber": "primaryInsurance.groupNumber",
  "primaryInsurance.groupName": "primaryInsurance.groupName",
  "primaryInsurance.patientRelationToInsured":
    "primaryInsurance.patientRelationToInsured",
  "secondaryInsurance.policyNumber": "secondaryInsurance.policyNumber",
  "secondaryInsurance.authorizationNumber":
    "secondaryInsurance.authorizationNumber",
  "secondaryInsurance.groupNumber": "secondaryInsurance.groupNumber",
  "secondaryInsurance.groupName": "secondaryInsurance.groupName",
  "secondaryInsurance.patientRelationToInsured":
    "secondaryInsurance.patientRelationToInsured",
  "caseInfo.externalCaseNumber": "caseInfo.externalCaseNumber",
  "caseInfo.dateReceived": "caseInfo.dateReceived",
  "caseInfo.dateCollected": "caseInfo.dateCollected",
  "caseInfo.clinicalHistory": "caseInfo.clinicalHistory",
  "caseInfo.indications": "caseInfo.indications",
  "caseInfo.impressions": "caseInfo.impressions",
  "caseInfo.ruleOuts": "caseInfo.ruleOuts",
  "caseInfo.sendingPracticeId": "caseInfo.sendingPracticeId",
  "caseInfo.physicianId": "caseInfo.physicianId",
  "caseInfo.surgeryCenterLabId": "caseInfo.surgeryCenterLabId",
  "caseInfo.submittingLabId": "caseInfo.submittingLabId",
  "caseInfo.originatingPracticeId": "caseInfo.originatingPracticeId",
  "caseInfo.originatingPhysicianId": "caseInfo.originatingPhysicianId",
  "caseInfo.originatingSurgeryCenterId": "caseInfo.originatingSurgeryCenterId",
  "caseInfo.consultationReason": "caseInfo.consultationReason",
  "caseInfo.consultationOriginalDiagnosis":
    "caseInfo.consultationOriginalDiagnosis",
  "caseInfo.consultationClinicalContext":
    "caseInfo.consultationClinicalContext",
  "caseInfo.requestingPathologist": "caseInfo.requestingPathologist",
  "caseInfo.shippingPathologist": "caseInfo.shippingPathologist",
  "caseInfo.shippingStreet": "caseInfo.shippingStreet",
  "caseInfo.shippingState": "caseInfo.shippingState",
  "caseInfo.shippingCity": "caseInfo.shippingCity",
  "caseInfo.shippingZipCode": "caseInfo.shippingZipCode",
};
